module.exports = __webpack_public_path__ + "img/clients1.7eb85fa9.jpg";